import React from "react";
import * as THREE from "three";
import { Text } from "@react-three/drei";
import { useBannerTexture } from "../hooks";
import { COLORS } from "../constants";

export default function EntranceArch() {
  const tex = useBannerTexture("TAB");
  return (
    <group position={[0, 0, 28]}>
      <mesh castShadow position={[-5, 3, 0]}>
        <boxGeometry args={[1.4, 6, 1.4]} />
        <meshStandardMaterial color={COLORS.stoneLight} roughness={0.85} />
      </mesh>
      <mesh castShadow position={[-5, 6.3, 0]}>
        <boxGeometry args={[1.8, 0.6, 1.8]} />
        <meshStandardMaterial color={COLORS.stone} roughness={0.85} />
      </mesh>
      <mesh castShadow position={[5, 3, 0]}>
        <boxGeometry args={[1.4, 6, 1.4]} />
        <meshStandardMaterial color={COLORS.stoneLight} roughness={0.85} />
      </mesh>
      <mesh castShadow position={[5, 6.3, 0]}>
        <boxGeometry args={[1.8, 0.6, 1.8]} />
        <meshStandardMaterial color={COLORS.stone} roughness={0.85} />
      </mesh>
      <mesh castShadow position={[0, 7.0, 0]}>
        <boxGeometry args={[12, 1, 1.4]} />
        <meshStandardMaterial color={COLORS.navyDeep} metalness={0.4} roughness={0.6} />
      </mesh>
      <mesh position={[0, 7.0, 0.72]}>
        <planeGeometry args={[10, 0.85]} />
        <meshStandardMaterial color={COLORS.navy} roughness={0.6} />
      </mesh>
      <Text
        position={[0, 7.0, 0.74]}
        fontSize={0.6}
        color={COLORS.goldBright}
        anchorX="center"
        anchorY="middle"
        letterSpacing={0.15}
      >
        THE ACADEMIC BOARDROOM
      </Text>
      <mesh position={[0, 5.4, 0.72]}>
        <planeGeometry args={[1.6, 2.4]} />
        <meshStandardMaterial map={tex} side={THREE.DoubleSide} roughness={0.8} />
      </mesh>
      <pointLight position={[-4, 6.5, 1]} intensity={0.5} distance={8} color={COLORS.gold} />
      <pointLight position={[4, 6.5, 1]} intensity={0.5} distance={8} color={COLORS.gold} />
    </group>
  );
}
